import HeroSection from './components/HeroSection';
import FeaturedCategories from './components/FeaturedCategories';
import LatestArticles from './components/LatestArticles';
import CommunitySection from './components/CommunitySection';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  const websiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://hatsunejima-fans.com/',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hatsunejima-fans.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'https://hatsunejima-fans.com/',
    description: siteInfo.description,
    email: siteInfo.email,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '上海',
      addressCountry: 'CN',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationLd)}</script>

      <main>
        <HeroSection />
        <FeaturedCategories />
        <LatestArticles />
        <CommunitySection />
        <FAQSection />
      </main>
    </>
  );
}